/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import css from './Blogger.module.scss';
import classNames from 'classnames';
import { copyText } from '../../../../../functions/copyText';
import { useFullWidth } from "../../../../../hooks/useFullWidth";

// Специфічна валідація для YouTube
const validateYoutube = (value) =>
  typeof value === 'string' &&
  (value.includes('youtube.com') || value.includes('youtube.com'));

// Специфічна валідація для Instagram
const validateInstagram = (value) => typeof value === 'string' && value.includes('instagram.com');

// Валідація email
const validateEmail = (value) =>
  typeof value === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const Settings = ({
  setSettingData,
  settingData,
  settingValidation,
  setSettingValidation,
  setSaveButtonState,
  saveButtonState,
}) => {
  useFullWidth(true);
  
  const handleChange = (key, value) => {
    setSaveButtonState(1);
    setSettingData((prev) => ({...prev, [key]: value}));
  };

  useEffect(() => {
    const newValidation = {
      youtube_link: settingData.youtube_link && !validateYoutube(settingData.youtube_link),
      instagram_link: settingData.instagram_link && !validateInstagram(settingData.instagram_link),
      contact_email: settingData.contact_email && !validateEmail(settingData.contact_email),
    };
    setSettingValidation(newValidation);
  }, [settingData]);

  return (
    <div className='card mb-8'>
      <div className='card-header border-0 p-8 pb-0'>
        <div className='card-title'>
          <span className='text-gray-900'>Настройки</span>
        </div>
      </div>
      <div className='card-body p-8'>
        <div className={css.settings}>
          <div className={css.column}>
            {/* Название блогера */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>Название блогера</label>
              <input
                className='form-control form-control-lg form-control-solid'
                value={settingData.name || ''}
                onChange={(e) => handleChange('name', e.target.value)}
              />
            </div>

            {/* YouTube */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                <span className={css.label}>
                  <span className={css.iconYoutube}></span>Youtube канал
                </span>
              </label>
              <div className={classNames(css.inputWrapper)}>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={settingData.youtube_link || ''}
                  placeholder="https://youtube.com"
                  onChange={(e) => handleChange('youtube_link', e.target.value)}
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(settingData.youtube_link || '')}
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
              {!!settingValidation?.youtube_link && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  Неправильная ссылка
                </div>
              )}
            </div>

            {/* Instagram */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                <span className={css.label}>
                  <i className='bi bi-instagram fs-2'></i>Instagram аккаунт
                </span>
              </label>
              <div className={classNames(css.inputWrapper)}>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={settingData.instagram_link || ''}
                  placeholder="https://instagram.com"
                  onChange={(e) => handleChange('instagram_link', e.target.value)}
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(settingData.instagram_link || '')}
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
              {!!settingValidation?.instagram_link && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  Неправильная ссылка
                </div>
              )}
            </div>
          </div>

          <div className={css.column}>
            {/* Email */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>Контакти</label>
              <div className={classNames(css.inputWrapper, css._t2)}>
                <span className={css.emblem}>
                  <i className='bi bi-envelope-fill fs-2'></i>
                </span>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={settingData.contact_email || ''}
                  placeholder="example@gmail.com"
                  onChange={(e) => handleChange('contact_email', e.target.value)}
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(settingData.contact_email || '')}
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
              {!!settingValidation?.contact_email && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  Неправильный формат
                </div>
              )}
            </div>

            {/* Телефон */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <div className={classNames(css.inputWrapper, css._t2)}>
                <span className={css.emblem}>
                  <i className='bi bi-telephone-fill fs-2'></i>
                </span>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={settingData.contact_phone || ''}
                  placeholder="+123456789"
                  onChange={(e) => {
                    let value = e.target.value;

                    // Забороняємо видалення "+" і не даємо вводити інші символи крім цифр
                    if (!value.startsWith('+')) value = '+' + value.replace(/\D/g, '');
                    else value = '+' + value.slice(1).replace(/\D/g, '');

                    handleChange('contact_phone', value);
                  }}
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(settingData.contact_phone || '')}
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
            </div>

            {/* Telegram */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <div className={classNames(css.inputWrapper, css._t2)}>
                <span className={css.emblem}>
                  <i className='bi bi-telegram fs-2'></i>
                </span>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={settingData.telegram_username || ''}
                  placeholder="@username"
                  onChange={(e) => {
                    let value = e.target.value;

                    // Забороняємо видалення "@" і пробіли
                    if (!value.startsWith('@')) value = '@' + value.replace(/@|\s/g, '');
                    else value = '@' + value.slice(1).replace(/@|\s/g, '');

                    handleChange('telegram_username', value);
                  }}
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(settingData.telegram_username || '')}
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
